document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Product gallery thumbnail swap
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-detail__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-thumb-src');
      });
    });
  }

  // Newsletter forms give lightweight inline feedback if Shopify redirects back with a success param
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    var forms = document.querySelectorAll('.newsletter__form');
    forms.forEach(function (form) {
      var note = document.createElement('p');
      note.textContent = 'Thanks — you are subscribed!';
      note.style.fontSize = '13px';
      note.style.marginTop = '10px';
      form.insertAdjacentElement('afterend', note);
    });
  }
});
